import { DeviceType } from '@/app/components/DeviceSelectionGallery/DeviceSelectionGallery.types'
import { programsNewCollection } from '@/reducers/programsNew'
import { elibleDeviceTypesFromLimits } from '@/types/programs-new/device-limits.utils'

export default function useMultiProgramEligibleDeviceTypes(
  utilityProgramId: number | null,
): { deviceTypes: 'all' | DeviceType[]; isLoadingOrIdle: boolean } {
  const { data: allPrograms, isLoadingOrIdle } =
    programsNewCollection.useFetch()

  if (!utilityProgramId) {
    return { deviceTypes: 'all', isLoadingOrIdle: isLoadingOrIdle }
  }

  const program = allPrograms?.find(
    (p) => p.utility_program.id === utilityProgramId,
  )

  if (!program) {
    return { deviceTypes: 'all', isLoadingOrIdle: isLoadingOrIdle }
  }

  return {
    deviceTypes: elibleDeviceTypesFromLimits(program.device_limits),
    isLoadingOrIdle,
  }
}
